const showMarriedFields = (marriedStatus) => marriedStatus === '0';
export default showMarriedFields;
